<script>
  export default {
    props: {
      fillColour: {
        type: String,
        default: 'tw-fill-primary',
      },
    },
  }
</script>

<template>
  <svg viewBox="0 0 62 60" width="62" height="60">
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      :class="fillColour">
      <path
        id="title-bg"
        d="M 20.099 0 C 31.316 0 41.099 6.118 46.274 15.19 L 61.224 29.5 L 46.762 43.919 C 41.731 53.479 31.679 60 20.099 60 L -0.03 60 L -0.042 0 L 20.099 0 Z"
        style=""></path>
    </g>
  </svg>
</template>
